import React, { useState } from "react";
import { RolesABM } from "./Roles/RolesABM";
import { RolesListado } from "./Roles/RolesListado";
import { type Rol } from "@/lib/api";
import { useRegisterOpcionesAbmNav } from "./opcionesAbmBreadcrumb";

type RolesView = "ABM" | "Listado";

export function RolesSection() {
  const [currentView, setCurrentView] = useState<RolesView>("Listado");
  const [selectedItem, setSelectedItem] = useState<Rol | null>(null);

  const handleEdit = (item: Rol) => {
    setSelectedItem(item);
    setCurrentView("ABM");
  };

  const handleBack = () => {
    setSelectedItem(null);
    setCurrentView("Listado");
  };

  const handleNew = () => {
    setSelectedItem(null);
    setCurrentView("ABM");
  };

  useRegisterOpcionesAbmNav(
    currentView === "ABM",
    selectedItem != null,
    handleBack
  );

  return (
    <div className="space-y-4">
      {currentView === "ABM" ? (
        <RolesABM
          selectedItem={selectedItem}
          onBack={handleBack}
          onSaved={handleBack}
        />
      ) : (
        <RolesListado onEdit={handleEdit} onNew={handleNew} />
      )}
    </div>
  );
}